<template>
  <transition
    @enter="enter"
    @leave="leave"
  >
    <div v-if="item" class="NewItemAlert" id="new-item-alert">
      <card class="card p-2 pt-3">
        <span class="content-name">
          <svg class="success" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
          </svg>
          <slot v-bind="item"></slot>
        </span>
        <span>
          <svg class="close" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor" @click="clear">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </span>
      </card>
    </div>
  </transition>
</template>

<script>

import transitionFunctionConstructor from "../mixins/transitionFunctionConstructor"

import addedNewItemTableAlert from "../mixins/addedNewItemTableAlert"

export default {
  mixins: [
    addedNewItemTableAlert,
    transitionFunctionConstructor(),
  ],
  props: {
    alertKey: String,
  },
  created() {
    if (!this.alertKey) return;
    
    this.item = this.getStoredAlertItem(this.alertKey)
  },
  beforeDestroy() {
    this.clearAlert(this.alertKey)
  },
  data() {
    return {
      item: null,
    }
  },
  methods: {
    clear() {
      this.clearAlert(this.alertKey)
      this.item = null
    },
  },
}

</script>

<style>

.NewItemAlert .success {
  color: #1ea300;
  margin-top: -2px;
}

.NewItemAlert .card-body {
  display: flex;
  width: 100%;
  flex-direction: row !important;
  justify-content: space-between !important;
}

.NewItemAlert a {
  color: initial;
  font-weight: bold;
  text-decoration: underline;
}

.NewItemAlert .close {
  color: rgb(110,110,110);
  cursor: pointer;
}

.content-name {
  transform: translateY(0px);
}

</style>
